module.exports = __webpack_public_path__ + "static/media/3-desktop.6c2eaf3e.jpg";